import Vue from 'vue'
import users from '../../api/users'

// initial state
const state = {
  users: {root: [], totalCount: 0}
}

// getters
const getters = {
  users: state => state.users
}

// actions
const actions = {
  getUsersByCompanyId: function (context, data) {
    users.getUsersByCompanyId(data, users => {
      context.commit('RECEIVE_USERS', { users })
    })
  }
}

// mutations
const mutations = {
  ['RECEIVE_USERS'] (state, { users }) {
    users.totalCount = parseInt(users.totalCount)
    state.users = users
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js